import { z } from 'zod'

/**
 * Search params schema for immigration application list.
 * Persists list state in URL so breadcrumb back returns to the same page (and filters).
 */
export const applicationListSearchSchema = z.object({
  page: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => {
      const raw = typeof val === 'number' ? val : val && val !== '' ? Number(val) : 1
      return Number.isFinite(raw) && raw > 0 ? raw : 1
    }),
  assigneeId: z
    .string()
    .optional()
    .transform((v) => {
      const t = v?.trim()
      return t?.length ? t : undefined
    }),
  reviewerId: z
    .string()
    .optional()
    .transform((v) => {
      const t = v?.trim()
      return t?.length ? t : undefined
    }),
})

export type ApplicationListSearchParams = z.infer<typeof applicationListSearchSchema>

/** URL search for application list (keys omitted when not in URL) */
export type ApplicationListUrlSearch = {
  page?: number
  assigneeId?: string
  reviewerId?: string
}
